import { render } from "./CsvImportResults.vue?vue&type=template&id=bc736846&scoped=true"
import script from "./CsvImportResults.vue?vue&type=script&lang=js"
export * from "./CsvImportResults.vue?vue&type=script&lang=js"

import "./CsvImportResults.vue?vue&type=style&index=0&id=bc736846&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc736846"]])

export default __exports__